import { S3_BUCKET_URL, POWERFUL_WOMEN_CATEGORY } from '@/constants';

import { ScreenControl } from './screens/Control';
import { ScreenControlResponse } from './screens/ControlResponse';
import { ScreenEmail } from './screens/Email';
import { ScreenKneelResponse } from './screens/KneelResponse';
import { ScreenName } from './screens/Name';
import { ScreenProtect } from './screens/Protect';
import { ScreenSettingUpProfile } from './screens/SettingUpProfile';
import { SummaryDeep } from './screens/SummaryDeep';
import { SummaryFinal } from './screens/SummaryFinal';
import { SummaryIntro } from './screens/SummaryIntro';
import { ScreenTools } from './screens/Tools';
import { ScreenVoiceStyle } from './screens/VoiceStyle';
import { ScreenWelcome } from './screens/Welcome';

import type { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: ScreenWelcome,
    images: [],
  },
  control: {
    component: ScreenControl,
    images: [],
  },
  control_response: {
    component: ScreenControlResponse,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/control-response/resist.png`,
      `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/control-response/depends.png`,
      `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/control-response/secretly_like.png`,
      `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/control-response/obey.png`,
    ],
  },
  summary_intro: {
    component: SummaryIntro,
    images: [], // Main image is loaded dynamically based on persona (lucy/jia) from webCampaign notes
    // Image is preloaded 2 screens ahead in Control.tsx using useSummaryPreload hook
  },
  kneel_response: {
    component: ScreenKneelResponse,
    images: [],
  },
  voice_style: {
    component: ScreenVoiceStyle,
    images: [],
  },
  tools: {
    component: ScreenTools,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/tools/whip.png`,
      `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/tools/chains.png`,
      `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/tools/rope.png`,
      `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/tools/gag.png`,
      `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/tools/choker.png`,
    ],
  },
  summary_deep: {
    component: SummaryDeep,
    images: [], // Main image is loaded dynamically based on persona (lucy/jia) from webCampaign notes
    // Image is preloaded 2 screens ahead in VoiceStyle.tsx using useSummaryPreload hook
  },
  protect: {
    component: ScreenProtect,
    images: [`${S3_BUCKET_URL}/layout-own-ai-dominate-v2/protect/image.png`],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  summary_final: {
    component: SummaryFinal,
    images: [], // Main image is loaded dynamically based on persona (lucy/jia) from webCampaign notes
    // Image is preloaded 2 screens ahead in Protect.tsx using useSummaryPreload hook
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [`${S3_BUCKET_URL}/layout-own-ai-dominate-v2/email/image.png`],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  life_control: null,
  control_response: null,
  kneel_response: null,
  voice_style: null,
  tools: null,
  name: '',
  ready_to_obey: null,
  email: '',
};

export const HARDCODED_CATEGORIES = [POWERFUL_WOMEN_CATEGORY];
